/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pre-op-check-list.reducer';

export const PreOpCheckListUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const preOpCheckListEntity = useAppSelector(state => state.preOpCheckList.entity);
  const loading = useAppSelector(state => state.preOpCheckList.loading);
  const updating = useAppSelector(state => state.preOpCheckList.updating);
  const updateSuccess = useAppSelector(state => state.preOpCheckList.updateSuccess);

  const handleClose = () => {
    navigate(`/pre-op-check-list${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.urinaryTime !== undefined && typeof values.urinaryTime !== 'number') {
      values.urinaryTime = Number(values.urinaryTime);
    }
    if (values.preOpMedsGivenTime !== undefined && typeof values.preOpMedsGivenTime !== 'number') {
      values.preOpMedsGivenTime = Number(values.preOpMedsGivenTime);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...preOpCheckListEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...preOpCheckListEntity,
          surgery: preOpCheckListEntity?.surgery?.id,
          anaesthesiologist: preOpCheckListEntity?.anaesthesiologist?.id,
          nurse: preOpCheckListEntity?.nurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preOpCheckList.home.createOrEditLabel" data-cy="PreOpCheckListCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preOpCheckList.home.createOrEditLabel">Create or edit a PreOpCheckList</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-op-check-list-id"
                  label={translate('tinyMedicRestApp.preOpCheckList.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.preparation')}
                id="pre-op-check-list-preparation"
                name="preparation"
                data-cy="preparation"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.vitals')}
                id="pre-op-check-list-vitals"
                name="vitals"
                data-cy="vitals"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.amCareSponge')}
                id="pre-op-check-list-amCareSponge"
                name="amCareSponge"
                data-cy="amCareSponge"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.amCareShower')}
                id="pre-op-check-list-amCareShower"
                name="amCareShower"
                data-cy="amCareShower"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.urinaryTime')}
                id="pre-op-check-list-urinaryTime"
                name="urinaryTime"
                data-cy="urinaryTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.urinaryCatheter')}
                id="pre-op-check-list-urinaryCatheter"
                name="urinaryCatheter"
                data-cy="urinaryCatheter"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.enemaBowlWash')}
                id="pre-op-check-list-enemaBowlWash"
                name="enemaBowlWash"
                data-cy="enemaBowlWash"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.enemaLaxatives')}
                id="pre-op-check-list-enemaLaxatives"
                name="enemaLaxatives"
                data-cy="enemaLaxatives"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.preOpMedsGiven')}
                id="pre-op-check-list-preOpMedsGiven"
                name="preOpMedsGiven"
                data-cy="preOpMedsGiven"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.preOpMedsGivenTime')}
                id="pre-op-check-list-preOpMedsGivenTime"
                name="preOpMedsGivenTime"
                data-cy="preOpMedsGivenTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.skinPreparation')}
                id="pre-op-check-list-skinPreparation"
                name="skinPreparation"
                data-cy="skinPreparation"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.nbm')}
                id="pre-op-check-list-nbm"
                name="nbm"
                data-cy="nbm"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.consent')}
                id="pre-op-check-list-consent"
                name="consent"
                data-cy="consent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.makingOfSite')}
                id="pre-op-check-list-makingOfSite"
                name="makingOfSite"
                data-cy="makingOfSite"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.medicationProfile')}
                id="pre-op-check-list-medicationProfile"
                name="medicationProfile"
                data-cy="medicationProfile"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.denturesRemoved')}
                id="pre-op-check-list-denturesRemoved"
                name="denturesRemoved"
                data-cy="denturesRemoved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.lensesRemoved')}
                id="pre-op-check-list-lensesRemoved"
                name="lensesRemoved"
                data-cy="lensesRemoved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.prostesisRemoved')}
                id="pre-op-check-list-prostesisRemoved"
                name="prostesisRemoved"
                data-cy="prostesisRemoved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.prostesisNames')}
                id="pre-op-check-list-prostesisNames"
                name="prostesisNames"
                data-cy="prostesisNames"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.jewelleryRemoved')}
                id="pre-op-check-list-jewelleryRemoved"
                name="jewelleryRemoved"
                data-cy="jewelleryRemoved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.highRiskConsent')}
                id="pre-op-check-list-highRiskConsent"
                name="highRiskConsent"
                data-cy="highRiskConsent"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.bloodType')}
                id="pre-op-check-list-bloodType"
                name="bloodType"
                data-cy="bloodType"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.bloodScreen')}
                id="pre-op-check-list-bloodScreen"
                name="bloodScreen"
                data-cy="bloodScreen"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.bloodHoldReady')}
                id="pre-op-check-list-bloodHoldReady"
                name="bloodHoldReady"
                data-cy="bloodHoldReady"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.pacDone')}
                id="pre-op-check-list-pacDone"
                name="pacDone"
                data-cy="pacDone"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.active')}
                id="pre-op-check-list-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.cursor')}
                id="pre-op-check-list-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.lastupdated')}
                id="pre-op-check-list-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.microSec')}
                id="pre-op-check-list-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpCheckList.timestampentry')}
                id="pre-op-check-list-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pre-op-check-list-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.preOpCheckList.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-check-list-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.preOpCheckList.anaesthesiologist')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-check-list-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.preOpCheckList.nurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-op-check-list" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreOpCheckListUpdate;
